import { render, staticRenderFns } from "./HospitalAdminListPage.vue?vue&type=template&id=fa2cbb58&scoped=true"
import script from "./HospitalAdminListPage.vue?vue&type=script&lang=js"
export * from "./HospitalAdminListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2cbb58",
  null
  
)

export default component.exports